export const dash = (v) =>
  v == null || (typeof v === 'string' && v.trim() === '') ? '—' : v;

export const fmtDateTimeGB = (value) => {
  if (!value) return '—';
  const opts = {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  };
  return new Date(value).toLocaleString('en-GB', opts);
};

export const computeCounts = (evnData = []) => {
  const evnCount = evnData.length;
  const meterCount = evnData.reduce(
    (sum, evn) => sum + (Array.isArray(evn.meters) ? evn.meters.length : 0),
    0
  );
  return { evnCount, meterCount };
};

export const getOperatorDisplay = (unitData) =>
  (unitData?.operatorDescription && unitData.operatorDescription.trim()) ||
  (unitData?.operatorCode && unitData.operatorCode.trim()) ||
  '—';

export const monthFmt = new Intl.DateTimeFormat('en-GB', { month: 'short' });
export const yearFmt  = new Intl.DateTimeFormat('en-GB', { year: 'numeric' });
export const dayFmt   = new Intl.DateTimeFormat('en-GB', { day: 'numeric' });

export function toNumOrNull(v) {
  if (v == null) return null;
  if (typeof v === 'string' && v.toLowerCase() === 'pending') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function normalizeUnitEnergyForChart(rows = []) {
  return rows.map(r => ({
    date: r?.ReadingDate ? new Date(r.ReadingDate) : null,
    ac: toNumOrNull(r?.ConsumptionAC),
    dc: toNumOrNull(r?.ConsumptionDC),
  }));
}

export function monthYearFromDates(dates = []) {
  if (!dates.length) return '';
  const first = dates[0];
  const last  = dates[dates.length - 1];
  const sameMonth = first.getMonth() === last.getMonth() && first.getFullYear() === last.getFullYear();
  if (sameMonth) return `${monthFmt.format(first)} ${yearFmt.format(first)}`;
  const sameYear = first.getFullYear() === last.getFullYear();
  if (sameYear) return `${monthFmt.format(first)}–${monthFmt.format(last)} ${yearFmt.format(first)}`;
  return `${monthFmt.format(first)} ${yearFmt.format(first)} – ${monthFmt.format(last)} ${yearFmt.format(last)}`;
}

export function fallbackRangeLabel(range) {
  const toLbl = (s) => (s ? new Date(s).toLocaleDateString('en-GB') : '');
  if (!range) return '';
  if (range.start && range.end) return `${toLbl(range.start)} – ${toLbl(range.end)}`;
  if (range.start) return `From ${toLbl(range.start)}`;
  if (range.end) return `To ${toLbl(range.end)}`;
  return '';
}

export function computeEffectiveDateRange(dateRange, startDate, endDate, localFallback) {
  if (startDate && endDate) return { start: startDate, end: endDate };
  const hasExplicitRange = dateRange && (dateRange.start || dateRange.end);
  return hasExplicitRange ? dateRange : (localFallback ?? undefined);
}

export function buildYAxis(scaleValues, step = 500, minMax = 2000) {
  const max = Math.max(...scaleValues.map(v => v ?? 0));
  const hasAny = Number.isFinite(max) && max > 0;
  const yMax = hasAny ? Math.max(minMax, Math.ceil((max * 1.1) / step) * step) : minMax;
  const ticks = hasAny
    ? Array.from({ length: Math.floor(yMax / step) + 1 }, (_, i) => i * step)
    : [0, 500, 1000, 1500, 2000];
  return { yMax, ticks };
}
